'use client';

import { FC, ReactElement, useEffect, useState } from 'react';
import type { FlagExperiment } from 'src/data/FlagsApi/FlagsApi.type';
import { getGroupForExperiment } from 'src/general/helpers/flags/getGroupForExperiment';
import { useABTestEvent } from './useABTestEvent';

type RendererProps = {
  experiment: FlagExperiment;
  controlComponent: ReactElement;
  variantComponent: ReactElement;
  LoadingComponent?: ReactElement;
};

type Props = Omit<RendererProps, 'experiment'> & {
  experiment: FlagExperiment | null;
};

export const ABTest: FC<Props> = ({ experiment, ...props }) => {
  if (!experiment) {
    console.warn(`Experiment is not configured. Defaulting to baseline component`);
    return props.controlComponent;
  }

  return <ABRestRenderer {...props} experiment={experiment} />;
};

const ABRestRenderer: FC<RendererProps> = ({ experiment, controlComponent, variantComponent, LoadingComponent }) => {
  const [loaded, setLoaded] = useState(false);
  const group = getGroupForExperiment(experiment);

  // Automatically track exposure event when component renders
  const { triggerEvent } = useABTestEvent(experiment, 'impression', { enabled: false });

  useEffect(() => {
    setLoaded(true);
    triggerEvent();
  }, []);

  if (!loaded && LoadingComponent) {
    return LoadingComponent;
  }

  return group === 'a' || !loaded ? controlComponent : variantComponent;
};
